module.exports = __webpack_public_path__ + "img/lyrica prismriver_sc2.19fcae10.png";